import { render, staticRenderFns } from "./CellHeading.vue?vue&type=template&id=56d358a3&scoped=true"
import script from "./CellHeading.vue?vue&type=script&lang=js"
export * from "./CellHeading.vue?vue&type=script&lang=js"
import style0 from "./CellHeading.vue?vue&type=style&index=0&id=56d358a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d358a3",
  null
  
)

export default component.exports